// This file will be no longer needed one https://github.com/openedx/paragon/pull/3045 is merged.
const NewsstandIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 -960 960 960"
    {...props}
  >
    <path
      d="M80-160v-80h800v80H80Zm80-160v-320h80v320h-80Zm160 0v-480h80v480h-80Zm160 0v-480h80v480h-80Zm280 0L600-600l70-40 160 280-70 40Z"
      fill="currentColor"
    />
  </svg>
);

export default NewsstandIcon;
